import { isAxiosError } from "axios";
import i18n, { t } from "i18next";
import axios from "../lib/axios";

export type WorkingHoursPreviewWorkEntry = {
  from: string;
  to: string;
  project: string;
};

export type WorkingHoursPreviewAbsence = {
  name: string;
  hourFrom: string | null;
  hourTo: string | null;
};

export type WorkingHoursPreviewDay = {
  date: string;
  workEntries: WorkingHoursPreviewWorkEntry[];
  absences: WorkingHoursPreviewAbsence[];
};

function resolveErrorMessage(error: unknown): string {
  let message = t("common.unknownErrorOccurred");

  if (isAxiosError(error)) {
    if (error.response) {
      if (error.response.status === 403) {
        message = t("noPermissions");
      } else if (error.response.data && "message" in error.response.data) {
        message = error.response.data.message;
      }
    } else if (error.request) {
      message = t("common.noResponseFromServer");
    }
  }

  return message;
}

export async function getAcceptanceStatus() {
  try {
    const response = await axios.get<{ accepted: boolean | null }>(
      "/api/accepted-working-hours/status",
      {
        headers: {
          "Accept-Language": i18n.language,
        },
      },
    );

    return { isOk: true as const, data: response.data };
  } catch (error) {
    return { isOk: false as const, error: resolveErrorMessage(error) };
  }
}

export async function getWorkingHoursPreview() {
  try {
    const response = await axios.get<WorkingHoursPreviewDay[]>(
      "/api/accepted-working-hours/preview",
      {
        headers: {
          "Accept-Language": i18n.language,
        },
      },
    );

    return { isOk: true as const, data: response.data };
  } catch (error) {
    return { isOk: false as const, error: resolveErrorMessage(error) };
  }
}

export async function acceptWorkingHours() {
  try {
    await axios.post("/api/accepted-working-hours", undefined, {
      headers: {
        "Accept-Language": i18n.language,
      },
    });

    return { isOk: true as const };
  } catch (error) {
    return { isOk: false as const, error: resolveErrorMessage(error) };
  }
}
